"use client";

import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { ApiErrorMessage } from "../ApiErrorMessage/ApiErrorMessage";
import { FormController } from "../ReactHookForm/FormController";
import { FormObserver } from "../ReactHookForm/FormObserver";
import { Box } from "../ui/box";
import { Button } from "../ui/button";
import { Center } from "../ui/center";
import { PinInput } from "../ui/pin-input";
import { Stack } from "../ui/stack";

/**
 * @typedef {object} Props
 * @prop {import("react-hook-form").UseFormReturn<import("./Handler").TwoFactorAuthChallengeFormValues>} form
 * @prop {() => void} submit
 * @prop {boolean} isLoading
 */
/**
 * @param {Props} props
 */
export function TwoFactorAuthChallengeForm({
  form: { control, getValues },
  submit,
  isLoading,
}) {
  const handleKeyDown = useCallback(
    /** @type {import("react").KeyboardEventHandler<HTMLDivElement>} */
    (e) => {
      if (e.key === "Enter") {
        const code = getValues("data.code");
        if (code.join("").length === 6) {
          submit();
        }
      }
    },
    [getValues, submit],
  );

  return (
    <Stack gap="16px">
      <Box>
        <ApiErrorMessage />

        <Center>
          <FormController
            control={control}
            name="data.code"
            render={(field) => (
              <PinInput
                otp={true}
                type="numeric"
                count={6}
                {...{ field, onChange: undefined }}
                onValueChange={({ value }) => field.onChange(value)}
                onKeyDown={handleKeyDown}
              />
            )}
          />
        </Center>
      </Box>

      <Center>
        <FormObserver control={control} name="data.code">
          {(code) => (
            <Button
              type="submit"
              disabled={code.join("").length !== 6}
              loading={isLoading}
              colorPalette="primary"
            >
              <FormattedMessage defaultMessage="Confirmer" />
            </Button>
          )}
        </FormObserver>
      </Center>
    </Stack>
  );
}
